<template>
<div class="row">
  <div class="flex xs12 sm12 lg4">
      <va-card class="xl12" >
    
      <p class="display-3 text-center">   Extras</p>
      <hr>
          <div class="modals">

            <!-- BOTOES CONTROLE -->
            <!-- <va-button color="info" @click="abrirModal()" >
          {{ $t('buttons.Adicionar') }}
          </va-button>   -->

          <!-- FIM CONTROLES -->

        <div class="row flex">

            <transition name="fade" mode="out-in">

          <div class="md12 xl12">
          
              <va-data-table
              :fields="fields"
              :data="allArquviosDisciplina"
              hoverable
              no-pagination
              > 
                  <template slot="marker" slot-scope="props">
                    <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
                  </template>
                  <template  slot="actions" slot-scope="props">
                    <va-button  small color="blurple" @click="visualizar(props.rowData)" class="ma-0">
                      {{$t('arealuno.Ver')}}
                    </va-button>
                  
                    <va-button  small color="info" @click="download_arquivo(props.rowData)" class="ma-0">
                      {{$t('arealuno.Download')}}
                    </va-button>


                  </template>
                  
            </va-data-table>

          </div>

        </transition>

        </div>

        <!-- Inicio Modal -->
          <div class="modal" v-show="showModal" >
            <div class="modal-wrapper">
              <div class="modal-container">
                <content select="modal-header">
                  <div class="modal-header">
                    <h3 class="text-center">
                      Extras
                    </h3>
                  </div>
                </content>
                <hr>
                <br>
              <!-- Inicio Tabela -->
                
                <!-- Fim Tabela -->
          
                <div class="text-center">
                    <va-button @click="showModal = false"  color="info" >Fechar</va-button>
                </div>
              </div>
            </div>
          </div>
          <!-- Fim Modal -->

        </div>
     </va-card>
  </div>
  <div class="flex xs12 sm12 lg8">
    <va-card>
      <p class="display-3 text-center">   Visualizar</p>
      <hr>
      <div class="tamanho_div" >
       
        <iframe class="tamanho_video" :src="src"></iframe>
    </div>
    </va-card>
  </div>

</div>
</template>

<script>

import pdf from 'vue-pdf'
export default {
  name: '',
   components: {
        pdf,
    },

  data () {
      return {
          showModal: false,
          disciplina: {
            id: this.$store.state.datamateria.setmateria.id,
            tipo_arquivo_id: 5,
          },
          ofertaArquivo: {},
          src:"",


            // src: loadingTask,
            // currentPage: 0,
            // pageCount: 0,
            // page:1

      }
    },
    created(){
      this.all();
    },
  computed: {
    
    allArquivosTipo (){ return this.$store.state.arquivos.allArquivosTipo   },
    allArquviosDisciplina (){ return this.$store.state.arquivos.allArquivosDisciplina   },
    
    fields () {
        return [{
          name: '__slot:marker',
          width: '30px',
          dataClass: 'text-center',
        }, {
          name: 'nome_arquivo',
          title: this.$t('tables.headings.name'),
        },{
          name: '__slot:actions',
          dataClass: 'text-right',
        }]
    },
  
  },

  methods: {
     
    async  visualizar(value){
       await  this.$store.dispatch('linkArquivo',value)
        let link = this.$store.state.arquivos.link_arquivo
      //  this.src = "http://api.ucpvirtual.com.br/storage/"+ link 
      this.src= link;

       // this.src = "https://docs.google.com/gview?url="+link+"&embedded=true"  // via google

      },



     mais_pagina(){
        this.page++
      },
      menos_pagina(){
        this.page--
      },

    abrirModal(){
    
      this.showModal = true
      this.$store.dispatch('allArquivosTipo',this.disciplina)
     
    },
    all() {
      this.$store.dispatch('allArquivosDisciplina',this.disciplina)
      
    },

    async  AddConteudo (value) {
      //console.log(value)
      this.ofertaArquivo = {
          oferta_arquivo_id:value.id,
          oferta_data_disciplina_id: this.disciplina.id,
          tipo_arquivo_id: 5
      }
      
    await this.$store.dispatch('AddAquivoDisciplina',this.ofertaArquivo)
      .then(() => {
        this.all()
      })
      .catch(() => {
         
        }).finally(()=>  this.all())
     
    },
    download_arquivo(value) {
    
      this.$store.dispatch('downloadArquivo',value)
      
    },
  },
   
}
</script>

<style lang="scss" scoped>

.tamanho_video
{
 width: 100%;
  height: 100%;
}
.tamanho_div
{
 width: 100%;
  height: 900px;
}

.borda 
{
  border-right: 1px solid black;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 1s ease;
}

.slide-fade-enter /*.slide-fade-leave-to*/
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}


// daqui para baixo é do modal
 .modal {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .5s ease;
  
  &-wrapper {
   // display: table-cell;
    vertical-align: middle;
  }
  
  &-container {
    background: #fff;
    width: 950px;
    min-height: 400px;
    border-radius: 5px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0);
  //  transition: all .3s ease;
    margin:  auto;
    margin-top: 100px;
    padding: 20px 30px;
  }
  
  &-footer {
    margin-top: 15px;
  }
  
  &-enter, &-leave {
    opacity: 0;
  }
  
  &-enter &-container,
  &-leave &-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
}

</style>